import { render, staticRenderFns } from "./RollGameWin.vue?vue&type=template&id=1bea4907&scoped=true"
import script from "./RollGameWin.vue?vue&type=script&lang=js"
export * from "./RollGameWin.vue?vue&type=script&lang=js"
import style0 from "./RollGameWin.vue?vue&type=style&index=0&id=1bea4907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea4907",
  null
  
)

export default component.exports